export interface CountryCode {
  code: string;
  dialCode: string;
  name: string;
}

export const countryCodes: CountryCode[] = [
  { code: "AR", dialCode: "+54", name: "Argentina" },
  { code: "BO", dialCode: "+591", name: "Bolivia" },
  { code: "BR", dialCode: "+55", name: "Brazil" },
  { code: "CA", dialCode: "+1", name: "Canada" },
  { code: "CL", dialCode: "+56", name: "Chile" },
  { code: "CO", dialCode: "+57", name: "Colombia" },
  { code: "EC", dialCode: "+593", name: "Ecuador" },
  { code: "FR", dialCode: "+33", name: "France" },
  { code: "DE", dialCode: "+49", name: "Germany" },
  { code: "IT", dialCode: "+39", name: "Italy" },
  { code: "MX", dialCode: "+52", name: "Mexico" },
  { code: "NL", dialCode: "+31", name: "Netherlands" },
  { code: "PY", dialCode: "+595", name: "Paraguay" },
  { code: "PE", dialCode: "+51", name: "Peru" },
  { code: "PT", dialCode: "+351", name: "Portugal" },
  { code: "ES", dialCode: "+34", name: "Spain" },
  { code: "GB", dialCode: "+44", name: "United Kingdom" },
  { code: "US", dialCode: "+1", name: "United States" },
  { code: "UY", dialCode: "+598", name: "Uruguay" },
  { code: "VE", dialCode: "+58", name: "Venezuela" },
];

export const formatPhoneWithCountryCode = (
  phone: string,
  countryDialCode: string
): string => {
  // Remove any non-numeric characters
  const cleanPhone = phone.replace(/\D/g, "");

  // Format the phone with the country code
  return `${countryDialCode} ${cleanPhone}`;
};

export const parsePhoneNumber = (
  fullPhone: string
): { dialCode: string; phoneNumber: string } => {
  // Try to extract the dial code and the phone number
  const match = fullPhone.match(/^(\+\d+)\s*(.*)$/);

  if (match) {
    return {
      dialCode: match[1],
      phoneNumber: match[2],
    };
  }

  // If no match is found, return the entire string as the phone number
  return {
    dialCode: "",
    phoneNumber: fullPhone,
  };
};
